import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import ReactCrop, { centerCrop, makeAspectCrop, convertToPixelCrop } from 'react-image-crop';

import 'react-image-crop/dist/ReactCrop.css';

export default function CropImage({ imgSrc, setValue }) {
  const [crop, setCrop] = useState();
  const [showCrop, setShowCrop] = useState(false);
  const [completedCrop, setCompletedCrop] = useState();

  const imgRef = useRef();

  async function updateFileValue() {
    const image = imgRef.current;

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    if (Number.isNaN(scaleX) || Number.isNaN(scaleY)) {
      return;
    }

    const canvas = new OffscreenCanvas(
      completedCrop.width * scaleX,
      completedCrop.height * scaleY,
    );

    const ctx = canvas.getContext('2d');

    // ctx.scale(pixelRatio, pixelRatio);
    ctx.imageSmoothingQuality = 'high';

    const cropX = completedCrop.x * scaleX;
    const cropY = completedCrop.y * scaleY;

    const centerX = image.naturalWidth / 2;
    const centerY = image.naturalHeight / 2;

    ctx.save();

    ctx.translate(-cropX, -cropY);
    ctx.translate(centerX, centerY);
    ctx.scale(1, 1);
    ctx.translate(-centerX, -centerY);

    ctx.drawImage(
      image,
      0,
      0,
      image.naturalWidth,
      image.naturalHeight,
      0,
      0,
      image.naturalWidth,
      image.naturalHeight,
    );

    ctx.restore();

    const blob = await canvas.convertToBlob({
      type: 'image/png',
    });

    const file = new File([blob], 'avatar.png', { type: 'image/png', lastModified: new Date().getTime() });
    const container = new DataTransfer();
    container.items.add(file);
    setValue(file);
  }

  useEffect(() => {
    setShowCrop(true);
  }, []);

  useEffect(() => {
    if (completedCrop) {
      updateFileValue();
    }
  }, [completedCrop]);

  const onImageLoad = (e) => {
    const { width, height } = e.currentTarget;

    const newCrop = centerCrop(
      makeAspectCrop(
        {
          unit: '%',
          width: 50,
        },
        1,
        width,
        height,
      ),
      width,
      height,
    );
    setCrop(newCrop);

    setCompletedCrop(convertToPixelCrop(newCrop, width, height));
  };

  return (
    <div className="w-100 h-100">
      {showCrop && (
        <ReactCrop
          key={crop}
          aspect={1}
          keepSelection
          ruleOfThirds
          onChange={(_, c) => setCrop(c)}
          onComplete={(c) => setCompletedCrop(c)}
          crop={crop}
        >
          <img
            ref={imgRef}
            className="mw-100 mh-100"
            alt="preview"
            src={imgSrc}
            onLoad={onImageLoad}
          />
        </ReactCrop>
      )}

    </div>
  );
}

CropImage.propTypes = {
  imgSrc: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
};
